import { render } from "./CatalogView.vue?vue&type=template&id=b7eb964c&scoped=true"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"

import "./CatalogView.vue?vue&type=style&index=0&id=b7eb964c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7eb964c"]])

export default __exports__